import React from 'react'
import cn from 'classnames'
import css from './imageOverlay.css'
type ImageOverlayProps = {
  isOpen: boolean
  image?: string
  onClose: (...args: Array<any>) => any
}

const ImageOverlay = ({ isOpen, image, onClose }: ImageOverlayProps) => {
  return (
    <div
      onClick={onClose}
      className={cn(css.overlay, {
        [css.visible]: isOpen,
      })}
    >
      <img src={image} alt={''} />
    </div>
  )
}

export default ImageOverlay
